import type { MonospaceWorkspace } from '#layers/data-model/public';
import type { createSystemFile } from './file';
import { defineRelations, withItemType } from '@rstore/vue';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';
import { defineSystemDateTimeFields, defineSystemDateTimeFieldTypes } from '~/rstore/utils/system-datetime-fields';

const WORKSPACE_DATETIME_FIELDS = ['dateCreated', 'dateUpdated'] as const;

export const Workspace = withItemType<MonospaceWorkspace>().defineCollection({
	getKey: (item) => item.apiName ?? item.id,
	name: 'MonospaceWorkspace',
	scopeId: MONOSPACE_SCOPE_ID,
	fields: defineSystemDateTimeFields(WORKSPACE_DATETIME_FIELDS),
	meta: {
		defaultFields: [
			'id',
			'apiName',
			'displayName',
			'description',
			'defaultLanguage',
			'logoId',
			'primaryColor',
			'apiNamingConvention',
			'dbNamingConvention',
			'dateCreated',
			'dateUpdated',
		],
		endpoint: 'system/workspaces',
		// Provisioning runs under the workspace registry lock; concurrent creates can
		// outlast the five-second budget used for ordinary requests.
		createTimeoutMs: 30_000,
		fetchOnCreate: true,
		primitiveFieldTypes: defineSystemDateTimeFieldTypes(WORKSPACE_DATETIME_FIELDS),
	},
});

export function createSystemWorkspaceRelations(file: ReturnType<typeof createSystemFile>) {
	return defineRelations(Workspace, ({ collection }) => ({
		logo: {
			to: collection(file, {
				on: {
					'SystemMonospaceFile.id': 'MonospaceWorkspace.logoId',
				},
			}),
		},
	}));
}
